import { render, staticRenderFns } from "./Lgx183908558784430080.vue?vue&type=template&id=2c977e03&"
import script from "./Lgx183908558784430080.vue?vue&type=script&lang=js&"
export * from "./Lgx183908558784430080.vue?vue&type=script&lang=js&"
import style0 from "./Lgx183908558784430080.vue?vue&type=style&index=0&id=2c977e03&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports